// @ts-nocheck
import React from 'react';
import { UnsafeHTML } from "./UnsafeHTML"
import { useAuth } from './AuthProvider';

export const Home = ({ title, props }) => {
    // static displayName = Home.name;
    var [auth] = useAuth();

    if (!auth.config) return <div>{JSON.stringify(auth)}</div>;

    return (
        <div class='form'>
            <img className='pageLogo' src={auth.config.bannerLogo} alt="Logo" />
   
        
            <UnsafeHTML html={auth.user ? auth.config.loggedInHomePage : auth.config.loggedOutHomePage} ></UnsafeHTML>

        </div>

      );

  
}
